<template>
<div class="animated fadeIn">
  <b-card show-footer class="bs-callout bs-callout-primary panelScrollBar" style="margin-bottom:12px;">
    <b-row style="min-width: 1200px;">
      <b-col sm="3">
        <div style="margin-top:-7px;">
          <span class="card-title wise-card-header">예산안 최적화 결과</span>
        </div>
        <div class="wise-small-header">Budget Allocation Result</div>
      </b-col>
      <b-col sm="3" class="brief">
        <div class="wise-small-header">캠페인 타이틀</div>
        <div><b>{{constFormData.campaignTitle}}</b></div>
      </b-col>
      <b-col sm="2" class="brief">
        <div class="wise-small-header">목표도달율 (%)</div>
        <div><b>{{constFormData.goalReach}}</b></div>
      </b-col>
      <b-col sm="2" class="brief">
        <div class="wise-small-header">최적화 모드</div>
        <div><b>미디어 목표 도달율</b></div>
        <div><b>Least Budget Mode</b></div>
      </b-col>
      <b-col sm="1">
        <div style="padding-top:10px">
          <b-button block variant="outline-success" class="btn-pill" @click="backtoForm()">
            <span style="font-weight:900;">입력 화면</span>
          </b-button>
        </div>
      </b-col>
      <b-col sm="1">
        <!-- <a href="download1">Download File 1</a> -->
        <div style="padding-top:10px">
          <b-button block variant="outline-primary" class="btn-pill" @click="excelDown()">
            <span style="font-weight:900;">엑셀 다운</span>
          </b-button>
        </div>
      </b-col>
      <b-col sm="12">
        <div style="padding-top:10px;font-size:12px;color:grey;font-weight:bold;text-align:center">
          광고효과예측솔루션은 미디어 계획에 대한 예상치를 제공할 수 있지만 특정 실적이나 결과를 보장하지는 않습니다.
          계획의 실제 실적은 광고 품질 등의 다양한 요인에 따라 달라질 수 있습니다.
        </div>
      </b-col>
      <b-collapse id="collapse1" class="mt-2" style="width:98%">
        <hr>
        <!-- <p class="card-text">{{formData}}</p> -->
        <b-row>
          <b-col sm=1></b-col>
          <b-col sm=10>
            <table style="border-color:transparent;width:100%">
              <thead>
                <tr class="wise-small-header">
                  <th >시뮬레이션 타이틀</th>
                  <th >광고주</th>
                  <th >대행사</th>
                  <th >업종</th>
                  <th >타겟</th>
                  <!-- <th >월배분1</th>
                  <th >월배분2</th>
                  <th >월배분3</th> -->
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>{{constFormData.simulationTitle}}</b></td>
                  <td><b>{{constFormData.advertiger.advt_NM}}</b></td>
                  <td><b>{{constFormData.agency.agc_NM}}</b></td>
                  <td><b>{{constFormData.industry.indt_NM}}</b></td>
                  <td><b>{{constFormData.targetCode}}</b></td>
                  <!-- <td><b>{{constFormData.monthly1}}</b></td>
                  <td><b>{{constFormData.monthly2}}</b></td>
                  <td><b>{{constFormData.monthly3}}</b></td> -->
                </tr>
              </tbody>
            </table>
          </b-col>
          <b-col sm=1></b-col>
        </b-row>
        <!-- <hr> -->
        <b-row style="padding-top:20px;">
          <b-col sm=1></b-col>
          <b-col sm=10>
            <b-table bordered hover :items="constFormData.mediaListResult" :fields="mediaListFields"></b-table>
          </b-col>
          <b-col sm=1></b-col>
        </b-row>
      </b-collapse>
    </b-row>
    <div slot="footer" v-b-toggle.collapse1 variant="primary" style="text-align:center"><b>예산안 최적화 정보 상세보기</b></div>
  </b-card>
  <b-card style="height:450px" class="bs-callout bs-callout-primary panelScrollBar">
      <!-- <resize-observer @notify="handleResize" /> -->
      <div style="min-width: 1200px;">
        <b-row style="padding-bottom:35px;">
          <b-col sm="6">
            <span class="float-left card-title wise-card-title"> 최대 도달율 </span>
            <budgetHelpResult01></budgetHelpResult01>
            <budgetHelpResult02></budgetHelpResult02>

            <span class="float-right" style="padding-right:15px">
              <b-button block variant="outline-primary" v-b-toggle.collapse2 class="btn-pill">
                <span style="font-weight:900;">채널정보 상세보기</span>
              </b-button>
            </span>
            <br/>
            <b-col sm="12">
              <br/>
              <b-row>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{finalMediaResult.totalMedia.resultMedia.reach1}}%</div>
                    <div>Reach</div>
                  </b-card>
                </b-col>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{totalBudget | separator}}</div>
                    <div>Budget</div>
                  </b-card>
                </b-col>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{finalMediaResult.totalMedia.resultMedia.af}}</div>
                    <div>A.F</div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-table id="mediaResultTable" :busy.sync="isBusy" ref="table" bordered hover
                    :items="displayMediaList"
                    @row-clicked="myRowClickHandler"
                    :fields="displayMediaListFields">
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
          </b-col>
          <b-col sm="1" ></b-col>
          <b-col v-if="!showResult" sm="5">
            <loading></loading>
          </b-col>
          <b-col v-show="showResult" sm="5" >
            <div  id="sunburstChart"></div>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-collapse id="collapse2" class="mt-2">
      <b-card style="height:450px" class="bs-callout bs-callout-primary panelScrollBar">
        <!-- <resize-observer @notify="handleResize" /> -->
        <div style="min-width: 1200px;">
          <b-row style="padding-bottom:35px;">
            <b-col sm="12">
              <span class="card-title wise-card-title">채널 목표 도달율 </span>
              <span class="small text-muted wise-card-subtitle"> Least Budget Mode</span>
            </b-col>
            <b-col sm="6" >
              <br />
              <b-row>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{mediaInfoForChannel.reach1}}%</div>
                    <div>Reach</div>
                  </b-card>
                </b-col>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{mediaInfoForChannel.budget | separator}}</div>
                    <div>Budget</div>
                  </b-card>
                </b-col>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{mediaInfoForChannel.af}}</div>
                    <div>A.F</div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" >
                  <b-table bordered hover
                    :items="displayChannelList"
                    :fields="displayChannelListFields">
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="6" >
              <div  id="mediaReachChartdiv" class="CSSAnimationChart"></div>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-collapse>
    <b-card style="height:450px" class="bs-callout bs-callout-primary panelScrollBar">
      <div style="min-width: 1200px;">
        <b-row style="padding-bottom:35px;">
          <b-col sm="12">
            <span class="card-title wise-card-title">미디어 목표 도달율 </span>
            <span class="small text-muted wise-card-subtitle"> Least Budget Mode</span>
          </b-col>
          <b-col v-if="!showResult" sm="12" >
            <loading></loading>
          </b-col>
          <b-col  v-show="showResult" sm="12" >
            <br />
            <div  id="mediaReachBarChartdiv" class="CSSAnimationChart"></div>
          </b-col>
        </b-row>
      </div>
    </b-card>
</div>
</template>


<script>
import amchart from "../../custom/amcharts/amcharts.js";
import serial from "../../custom/amcharts/serial.js";
import light from "../../custom/amcharts/themes/light.js";
import pie from "../../custom/amcharts/pie.js";
import reachFormData from "../common/ReachFormData.js";
import reachLogic from "../common/ReachLogic.js";
import channelReachResultChart from "./mediaReachResultChart.js";
import mediaReachResultBarChart from "./mediaReachResultBarChart.js";
import * as d3 from "d3v4/build/d3.min.js";
import numeral from 'numeral';
import loading from '../common/blockLoading.vue'; // 로딩중
import targetPortionUtils from "../common/targetPortionUtils.js";
import leftSideUtil from "../common/LeftSideUtil.js"

import budgetHelpResult01 from "../helpModals/budget/budgetHelpResult01.vue";
import budgetHelpResult02 from "../helpModals/budget/budgetHelpResult02.vue";

const moment = require("moment");
import swal from 'sweetalert2';
export default {
  components: {
    budgetHelpResult01,
    budgetHelpResult02,
    loading
  },
  data(){
    return {
      showResult : false,
      isBusy: false, // Bootstrap Table 용 , 정말필요한지는 확인 필요
      mediaListFields: [ // 사용자가 선택한 미디어/채널 기본정보 테이블 필드
        {
          key: 'media',
          label: '미디어',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'channel',
          label: '채널',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'cpm',
          label: 'CPM',
          formatter: (value) => { return numeral(value).format('0,0') },
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
      ],
      mediaListFields2th: [ // 사용자가 선택한 미디어/채널 기본정보 테이블 필드
        {
          key: 'media',
          label: '미디어',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'channel',
          label: '채널',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'cpm',
          label: 'CPM',
          formatter: (value) => { return numeral(value).format('0,0') },
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'minmumAllocationPortion',
          label: '할당비율',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'portionComparator',
          label: '부등호',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
      ],
      displayMediaListFields: [ // 미디어레벨 예측 결과 테이블 필드 정의
        {
          key: 'media',
          label: 'media',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'budgetRatio',
          label: '배분비율',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'budget',
          label: 'budget',
          formatter: (value) => { return numeral(value).format('0,0') },
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'grps',
          label: 'grps',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'reach1',
          label: 'reach1',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'af',
          label: 'A.F',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
      ],
      displayChannelListFields: [ // 채널레벨 예측 결과 테이블 필드 정의
        {
          key: 'channel',
          label: 'channel',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'budgetRatio',
          label: '배분비율',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'budget',
          label: 'budget',
          formatter: (value) => { return numeral(value).format('0,0') },
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'grps',
          label: 'grps',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'reach1',
          label: 'reach1',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'af',
          label: 'A.F',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
      ],
      constFormData: this.$session.get('budgetMediaInputFormData'),
      formData: this.$session.get('budgetMediaInputFormData'),
      formDataA: this.$session.get('budgetMediaInputFormData'),
      formDataB: this.$session.get('budgetMediaInputFormData'),
      inte_cffcnt : this.$session.get('inte_cffcnt'),
      inteMedia:{
          tvMedia:{
            inte_ModelCode:'',
            overall:null,
            mediaList: {},
            mediaListArr: [],
            resultMedia:null,
            screenCount: 1,
          },
          mobileMedia :{
            inte_ModelCode:'',
            overall:null,
            mediaList: {},
            mediaListArr: [],
            etcMediaList:[],
            resultMedia:null,
            screenCount: 1,
          },
          pcMedia:{
            inte_ModelCode:'',
            overall:null,
            mediaList: {},
            mediaListArr: [],
            etcMediaList:[],
            resultMedia:null,
            screenCount: 1,
          },
          digitalMedia:{
            inte_ModelCode:'',
            overall:null,
            mediaList: {},
            mediaListArr: [],
            etcMediaList:[],
            resultMedia:null,
            screenCount: 1,
          },
          totalMedia:{
            reachA:0.0,
            reachB:0.0,
            reachC:0.0,
            resultMedia:null,
          },
      },
      totalBudget:1,
      incrementBudget: 1,
      finalMediaResult:{
                  totalMedia:{
                    resultMedia:{reach1:0.0}
                },
      },
      displayMediaList:[],
      displayChannelList:[],
      mediaInfoForChannel:{},
      mediaIndexA:[1, 1, 1, 1, 1, 1, 1, 1, 1],
      mediaIndexB:[1, 1, 1, 1, 1, 1, 1, 1, 1],
      mediaSunburstData:{
        "name": "flare",
        "children": []
      },
      allocationMediaList:[]
    }
  },
  created: function() {
    console.log('최소예산안모드실행');
  },
  updated: function(){
  },
  mounted: function() {
    this.showResult = false;
    leftSideUtil.highLightMenu('budgetCustomId8642');

    for(var i=0; i<this.constFormData.mediaListResult.length; i++){
      this.constFormData.mediaListResult[i].minmumAllocationPortion = parseInt(this.constFormData.mediaListResult[i].minmumAllocationPortion);
    }

    this.doBudgetAllocationHandler();
  },
  methods: {
    backtoForm(){
      window.location.href = "#/budget/budget";
    },
    doBudgetAllocationHandler(){
      this.$log.debug('doBudgetAllocationHandler (전체 프로세스 핸들링 시작)');
      this.$log.debug('doBudgetAllocationHandler 채널수 : ' + this.formData.mediaListResult.length);
      this.$log.debug('doBudgetAllocationHandler 월배분 : ' + this.constFormData.montlyAllocation);
      this.$log.debug('doBudgetAllocationHandler 최소예산 할당비율 : ' + this.constFormData.allocationPortionON);
      if(this.constFormData.allocationPortionON){
        this.mediaListFields = this.mediaListFields2th;
      }
      //
      var self = this;
      var incrementRatio= this.constFormData.goalReach * 0.03; // 증감률 상수 값
      var reachMinusRatio = 1; // 목표값과 계산값의 차이
      var cnt = 0; // 시행 회수

      var calculationInterval = setInterval(function() {
        self.totalBudget = self.incrementBudget * 1000000;
        // self.totalBudget = self.incrementBudget;
        self.budgetChange();
        self.doBudgetAllocation(cnt, calculationInterval);

        // 변수값 조정 , 자동예산 증액 로직의 핵심부분
        reachMinusRatio = ( self.constFormData.goalReach - self.finalMediaResult.totalMedia.resultMedia.reach1 ) / self.constFormData.goalReach;
        self.incrementBudget = self.incrementBudget * (reachMinusRatio * incrementRatio + 1);

        // 탈출 조건
        // (1) 목표리치와 계산리치의 차이가 0.0001 보다 작은경우
        // 반복시행이 100을 초과한 경우
        if(reachMinusRatio < 0.0001 || cnt>100){ // or 0.01
          clearInterval(calculationInterval);
        }else{
        }
        cnt++;
        // (6) 반복시행
      } ,1000);
      this.$log.debug('doBudgetAllocationHandler (전체 프로세스 핸들링 종료)');
    },
    doBudgetAllocation(cnt, calculationInterval){
      this.$log.debug('doBudgetAllocation 시작');
      // index_1 예산 분배 Logic A (기본)
      var logicAObject = this.allocationBudgetNScreenLogicA(this.formData.mediaListResult.length);
      var finalA = 0;
      for(var i=0; i<this.formData.mediaListResult.length;i++){ // cntNumber = 채널갯수
        finalA += this.mediaIndexA[i];
      }
      // index_2 예산 분배 Logic B (max 리치 체크로직 추가)
      var logicBObject = this.allocationBudgetNScreenLogicB(this.formData.mediaListResult.length);
      var finalB = 0;
      for(var i=0; i<this.formData.mediaListResult.length;i++){ // cntNumber = 채널갯수
        finalB += this.mediaIndexB[i];
      }
      if(this.constFormData.allocationPortionON == true){
        if(finalA !== 100 && finalB !== 100 ){
          clearInterval(calculationInterval);
          swal({
            type: 'error',
            text: '할당비율을 수정하세요'
          }).then((result) => {
            this.backtoForm();
          })
        }
      }
      // index_3 LogicA 와 LogicB 결과 비교 후 최종 결과 선택 , 채널별 budgetRatio 할당
      this.$log.debug('doBudgetAllocation A로직 Reach1 : ' + logicAObject.totalMedia.resultMedia.reach1 );
      this.$log.debug('doBudgetAllocation B로직 Reach1 : ' + logicBObject.totalMedia.resultMedia.reach1 );
      if(logicAObject.totalMedia.resultMedia.reach1 >= logicBObject.totalMedia.resultMedia.reach1 ){
        this.finalMediaResult = logicAObject;
        this.formData = this.formDataA;
        for(var i=0;i<this.formData.mediaListResult.length; i++){
          this.formData.mediaListResult[i].budgetRatio = this.mediaIndexA[i];
        }
      }else{
        this.finalMediaResult = logicBObject;
        this.formData = this.formDataB;
        for(var i=0;i<this.formData.mediaListResult.length; i++){
          this.formData.mediaListResult[i].budgetRatio = this.mediaIndexB[i];
        }
      }
      // index_4 화면에 보여줄 결과 데이터 만들기
      this.makeDisplayData(cnt);
      this.makeSunburstData();

      var self = this;
      setTimeout(function() {
        self.selectFirstRow();
        self.createSunburst();
      }, 1500);
      this.$log.debug('doBudgetAllocation 종료');
    },
    // index_1 예산 분배 Logic A (기본)
    allocationBudgetNScreenLogicA(cntNumber){ // cntNumber 채널 개수
      this.$log.debug('A로직 allocationBudgetNScreenLogicA 시작 cntNumber : ' + cntNumber);
      var mediaIndexResult = [1, 1, 1, 1, 1, 1, 1, 1, 1]; // 최소버젯이 있으면 할당 시켜 놓고 작업, 최대 채널 9개
      var reachResultList = [0, 0, 0, 0, 0, 0, 0, 0, 0]; // 최대 채널 9개
      var reachObjectResultList = [null, null, null, null, null, null, null, null, null]; // 최대 채널 9개
      // var reachResultCheckSum = [true , true , true]; // 하나라도 false가 있으면 모든 mediaIndex에 +1 을 한다.
      var formDataArr = [null, null, null, null, null, null, null, null, null]; // 최대 채널 9개
      // 최소 배분 비율 적용
      if(this.constFormData.allocationPortionON == true){
        for(var i=0; i<this.constFormData.mediaListResult.length; i++){
          if(this.constFormData.mediaListResult[i].portionComparator == '<' ||
              this.constFormData.mediaListResult[i].portionComparator == '=='){
            mediaIndexResult[i] = parseInt(this.constFormData.mediaListResult[i].minmumAllocationPortion);
          }
        }
        this.mediaIndexA = this.$_.clone(mediaIndexResult);
      }
      // 100번 순회
      for(var cnt=0; cnt<100; cnt++){ // 100 번안에 무조건 끝나는 로직
        for(var i=0; i<cntNumber; i++){
          this.mediaIndexA[i]+=1;
          if(this.constFormData.allocationPortionON == true){
            if(this.constFormData.mediaListResult[i].portionComparator == '=='){
              this.mediaIndexA[i] = parseInt(this.constFormData.mediaListResult[i].minmumAllocationPortion);
            }else if(this.constFormData.mediaListResult[i].portionComparator == '>'){
              if(this.mediaIndexA[i] >= this.constFormData.mediaListResult[i].minmumAllocationPortion){
                this.mediaIndexA[i] = this.constFormData.mediaListResult[i].minmumAllocationPortion-1;
              }
            }
          }

          var tmpFormData = $.extend(true, {}, this.formDataA)
          formDataArr[i] = tmpFormData;
          reachObjectResultList[i] = this.calcChannelLevelReach(this.mediaIndexA, tmpFormData);
          reachResultList[i] = reachObjectResultList[i].totalMedia.resultMedia.reach1;
          // this.mediaIndexA = this.$_.clone(mediaIndexResult);
          this.mediaIndexA = $.extend(true, {}, mediaIndexResult);
        }
        var maxIndex = 0;
        var maxValue = 0;
        for(var i=0; i<cntNumber;i++){
          if(maxValue < reachResultList[i]){
            maxIndex = i;
            maxValue = reachResultList[i];
          }
        }

        if(this.constFormData.allocationPortionON == true){
          // for(var i=0; i<cntNumber;i++){
          if(this.constFormData.mediaListResult[maxIndex].portionComparator == '=='){
              mediaIndexResult[maxIndex] = parseInt(this.constFormData.mediaListResult[maxIndex].minmumAllocationPortion);
            }else if(this.constFormData.mediaListResult[maxIndex].portionComparator == '>'){
              mediaIndexResult[maxIndex] +=1;
              if(mediaIndexResult[maxIndex] >= this.constFormData.mediaListResult[maxIndex].minmumAllocationPortion){
                mediaIndexResult[maxIndex] = this.constFormData.mediaListResult[maxIndex].minmumAllocationPortion-1;
              }
            }else{
              mediaIndexResult[maxIndex] +=1;
            }
          // }
        }else{
          mediaIndexResult[maxIndex] +=1; // 최대 Reach1가 나온 배분비율 경우에 배분비율+1을 한다.(1을 더한다)
        }
        // this.mediaIndexA = this.$_.clone(mediaIndexResult);
        this.mediaIndexA = $.extend(true, {}, mediaIndexResult);

        var final = 0;
        for(var i=0; i<cntNumber;i++){
          final += mediaIndexResult[i];
        }
        if(final >=100){
          break;
        }
      }
      this.formDataA = $.extend(true, {}, formDataArr[maxIndex]);
      this.$log.debug('A로직 allocationBudgetNScreenLogicA 최종 배분 비율 : ', this.mediaIndexA);
      this.$log.debug('A로직 allocationBudgetNScreenLogicA 최종 결과 : ', reachObjectResultList[maxIndex]);
      this.$log.debug('A로직 allocationBudgetNScreenLogicA 종료');
      return reachObjectResultList[maxIndex];
    },
    // index_2 예산 분배 Logic B (max 리치 체크로직 추가)
    allocationBudgetNScreenLogicB(cntNumber){
      this.$log.debug('B로직 allocationBudgetNScreenLogicB 시작');
      var mediaIndexResult = [1, 1, 1, 1, 1, 1, 1, 1, 1]; // 최소버젯이 있으면 할당 시켜 놓고 작업, 최대 채널 9개
      var reachResultList = [0, 0, 0, 0, 0, 0, 0, 0, 0]; // 최대 채널 9개
      var reachObjectResultList = [null, null, null, null, null, null, null, null, null]; // 최대 채널 9개
      // var reachResultCheckSum = [true , true , true]; // 하나라도 false가 있으면 모든 mediaIndex에 +1 을 한다.
      var formDataArr = [null, null, null, null, null, null, null, null, null]; // 최대 채널 9개

      // 최소 배분 비율 적용
      if(this.constFormData.allocationPortionON == true){
        for(var i=0; i<this.constFormData.mediaListResult.length; i++){
          if(this.constFormData.mediaListResult[i].portionComparator == '<' ||
              this.constFormData.mediaListResult[i].portionComparator == '=='){
            mediaIndexResult[i] = parseInt(this.constFormData.mediaListResult[i].minmumAllocationPortion);
          }
        }
        this.mediaIndexB = this.$_.clone(mediaIndexResult);
      }

      // 100번 순회
      for(var cnt=0; cnt<100; cnt++){ // 100 번안에 무조건 끝나는 로직
        for(var i=0; i<cntNumber; i++){
          this.mediaIndexB[i]+=1;
          if(this.constFormData.allocationPortionON == true){
            if(this.constFormData.mediaListResult[i].portionComparator == '=='){
              this.mediaIndexB[i] = parseInt(this.constFormData.mediaListResult[i].minmumAllocationPortion);
            }else if(this.constFormData.mediaListResult[i].portionComparator == '>'){
              if(this.mediaIndexB[i] >= this.constFormData.mediaListResult[i].minmumAllocationPortion){
                this.mediaIndexB[i] = this.constFormData.mediaListResult[i].minmumAllocationPortion-1;
              }
            }
          }
          var tmpFormData = $.extend(true, {}, this.formDataB)
          formDataArr[i] = tmpFormData;
          reachObjectResultList[i] = this.calcChannelLevelReach(this.mediaIndexB, tmpFormData);
          reachResultList[i] = reachObjectResultList[i].totalMedia.resultMedia.reach1;
          // this.mediaIndexB = this.$_.clone(mediaIndexResult);
          this.mediaIndexB = $.extend(true, {}, mediaIndexResult);
        }
        var checkLogicB = false;
        var maxIndex = 0;
        var maxValue = 0;
        for(var i=0; i<cntNumber;i++){
          if(maxValue < reachResultList[i]){
            maxIndex = i;
            maxValue = reachResultList[i];
          }
          // 통합리치와 개발리치가 같은 경우가 있다면 checkLogicB를 True로 설정
          if(reachObjectResultList[i].totalMedia.resultMedia.reach1 == reachObjectResultList[i].totalMedia.reachA ||
             reachObjectResultList[i].totalMedia.resultMedia.reach1 == reachObjectResultList[i].totalMedia.reachB ||
             reachObjectResultList[i].totalMedia.resultMedia.reach1 == reachObjectResultList[i].totalMedia.reachC
            ){
               checkLogicB = true;
               maxIndex = i;
               break;
          }
        }

        if(checkLogicB){
          for(var i=0; i<cntNumber;i++){
            // mediaIndexResult[i] +=1; // 모든 채널에 배분비율을 +1한다.
            if(this.constFormData.allocationPortionON == true){
              if(this.constFormData.mediaListResult[i].portionComparator == '=='){
                mediaIndexResult[i] = parseInt(this.constFormData.mediaListResult[i].minmumAllocationPortion);
              }else if(this.constFormData.mediaListResult[i].portionComparator == '>'){
                mediaIndexResult[i] +=1;
                if(mediaIndexResult[i] >= this.constFormData.mediaListResult[i].minmumAllocationPortion){
                  mediaIndexResult[i] = this.constFormData.mediaListResult[i].minmumAllocationPortion-1;
                }
              }else{
                mediaIndexResult[i] +=1;
              }
            }else{
              mediaIndexResult[i] +=1; // 모든 채널에 배분비율을 +1한다.
            }
          }
        }else{
          if(this.constFormData.allocationPortionON == true){
            // for(var i=0; i<cntNumber;i++){
            if(this.constFormData.mediaListResult[maxIndex].portionComparator == '=='){
              mediaIndexResult[maxIndex] = parseInt(this.constFormData.mediaListResult[maxIndex].minmumAllocationPortion);
            }else if(this.constFormData.mediaListResult[maxIndex].portionComparator == '>'){
              mediaIndexResult[maxIndex] +=1;
              if(mediaIndexResult[maxIndex] >= this.constFormData.mediaListResult[maxIndex].minmumAllocationPortion){
                mediaIndexResult[maxIndex] = this.constFormData.mediaListResult[maxIndex].minmumAllocationPortion-1;
              }
            }else{
              mediaIndexResult[maxIndex] +=1;
            }
            // }
          }else{
            mediaIndexResult[maxIndex] +=1; // 최대 Reach1가 나온 배분비율 경우에 배분비율+1을 한다.(1을 더한다)
          }
        }
        // this.mediaIndexB = this.$_.clone(mediaIndexResult);
        this.mediaIndexB = $.extend(true, {}, mediaIndexResult);

        var final = 0;
        for(var i=0; i<cntNumber;i++){
          final += mediaIndexResult[i];
        }
        if(final >=100){
          break;
        }
      }
      this.formDataB = $.extend(true, {}, formDataArr[maxIndex]);
      this.$log.debug('B로직 allocationBudgetNScreenLogicB 최종 배분 비율 : ', this.mediaIndexB);
      this.$log.debug('B로직 allocationBudgetNScreenLogicB 최종 결과 : ', reachObjectResultList[maxIndex]);
      this.$log.debug('B로직 allocationBudgetNScreenLogicB 시작');
      return reachObjectResultList[maxIndex];
    },
    calcChannelLevelReach(mediaIndex, formData){
      var length = formData.mediaListResult.length ;
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      var portionList = new Map(); // 타겟 배분비율 로직 관련
      targetPortionUtils.getTargetPortionList(portionList); // 타겟 배분비율 로직 관련
      var outputGender = this.formData.gender; // 타겟 배분비율 로직 관련

      // 타겟 배분비율 로직 [Start]
      for(var i=0; i<length; i++){
        var cpm = formData.mediaListResult[i].cpm;
        var budget = (this.totalBudget) * mediaIndex[i] / 100;

        var tmpEImp = (budget / cpm ) * 1000;
        var emp = (budget / cpm ) * 1000;

        var inputGender = formData.mediaListResult[i].gender;
        var channel = formData.mediaListResult[i].channel;
        if(channel != 'Facebook' && channel != 'Youtube' && channel != 'SMR' ){
          channel = formData.mediaListResult[i].media;
        }
        if(outputGender == inputGender){
          var tmpChannelGender = channel + '_' + outputGender;
          emp = this.calcOutputImpression(formData.mediaListResult[i], tmpChannelGender, portionList, tmpEImp);
        }else if(outputGender == 'MF'){
          // inputTarget의 Gender 활용
          var tmpChannelGender = channel + '_' + inputGender;
          emp = this.calcOutputImpression(formData.mediaListResult[i], tmpChannelGender, portionList, tmpEImp);
        }else if(inputGender == 'MF'){
          // outputTarget의 Gender 활용
          var tmpChannelGender = channel + '_' + outputGender;
          emp = this.calcOutputImpression(formData.mediaListResult[i], tmpChannelGender, portionList, tmpEImp);
        }else {
          // inputTarget과 outputTarget의 성별이 다른경우
        }
        // 타겟 배분비율 로직 [End]

        var grps = ((emp / this.formData.demographic_cnt) * 100); // 배분비율이 적용된 OutputTarget으로 GRPs 계산
        var mediaReach1 = reachLogic.rgpReachCalc(formData.mediaListResult[i], grps);

        formData.mediaListResult[i].budget = budget;
        formData.mediaListResult[i].eImp = emp;  // 타겟 배분비율 로직 관련
        formData.mediaListResult[i].grps = grps;
        formData.mediaListResult[i].reach1 = mediaReach1;
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // mediaLevel reach 구하기
      var result = reachLogic.classifyMedia(formData.mediaListResult, $.extend(true, {}, this.inteMedia));

      if(result.tvMedia.inte_ModelCode != ""){
        reachLogic.calcTVMedia(result.tvMedia, this.inte_cffcnt);
      };
      if(result.pcMedia.inte_ModelCode != ""){
        reachLogic.calcDigitalMedia(result.pcMedia, this.inte_cffcnt);
      };
      if(result.mobileMedia.inte_ModelCode != ""){
        reachLogic.calcDigitalMedia(result.mobileMedia, this.inte_cffcnt);
      };
      if(result.digitalMedia.inte_ModelCode != ""){
        reachLogic.calcDigitalMedia(result.digitalMedia, this.inte_cffcnt);
      };

      // totalLevel reach 구하기
      var totalLevelCode = reachLogic.makeTotalLevelCode(result);
      reachLogic.calcTotalLevel(totalLevelCode, result, this.inte_cffcnt);
      return $.extend(true, {}, result);
    },
    calcOutputImpression(mediaResult, tmpChannelGender, portionList, eImp){
      var outputPortionSum = 0.0;
      var outputPortionList = portionList.get(tmpChannelGender);
      var intersectedCode = mediaResult.intersectedCode;
      for(var j=0; j< intersectedCode.length; j++){
        if(intersectedCode[j] == 1){
          outputPortionSum += outputPortionList[j].portion;
        }
      }
      mediaResult.outputPortionSum = outputPortionSum;
      // outputImpression 계산 : (e.Impression * outputPortion / inputPortion)
      return parseInt(
        parseFloat(eImp) * outputPortionSum / mediaResult.portionSum
      )
    },
    // index_4 화면에 보여줄 결과 데이터 만들기
    makeDisplayData(cnt){
      this.$log.debug('makeDisplayData 시작 , 화면에 보여줄 결과 데이터 만들기');

      var allocationMedia = {};
      allocationMedia.index = cnt;
      this.finalMediaResult.totalMedia.resultMedia.reach1 = this.finalMediaResult.totalMedia.resultMedia.reach1.toFixed(2);
      this.finalMediaResult.totalMedia.resultMedia.af =
      (this.finalMediaResult.totalMedia.resultMedia.grps / this.finalMediaResult.totalMedia.resultMedia.reach1).toFixed(2);

      this.displayMediaList // 여기다 push 인데

      if(this.finalMediaResult.tvMedia.resultMedia != null){
        var resultMedia = this.$_.clone(this.finalMediaResult.tvMedia.resultMedia);
        resultMedia.budgetRatio = 0;
        for(var i=0; i<this.formData.mediaListResult.length; i++){
          if(this.formData.mediaListResult[i].media == 'TV'){
            resultMedia.budgetRatio += this.formData.mediaListResult[i].budgetRatio;

            var channel = this.formData.mediaListResult[i].channel;
            this.finalMediaResult.tvMedia.mediaList[channel].budgetRatio = this.formData.mediaListResult[i].budgetRatio;
            this.formData.mediaListResult[i].grps = this.formData.mediaListResult[i].grps.toFixed(2);
            this.formData.mediaListResult[i].reach1 = this.formData.mediaListResult[i].reach1.toFixed(2);
            this.formData.mediaListResult[i].af = (this.formData.mediaListResult[i].grps/this.formData.mediaListResult[i].reach1).toFixed(2);
            this.formData.mediaListResult[i].budget = ((this.formData.mediaListResult[i].budgetRatio /100) * (this.totalBudget)).toFixed(2);

            this.formData.mediaListResult[i].name = this.formData.mediaListResult[i].channel;
            this.formData.mediaListResult[i].size = this.formData.mediaListResult[i].budgetRatio;

            this.finalMediaResult.tvMedia.mediaListArr.push(this.$_.clone(this.formData.mediaListResult[i]));
          }
        }

        resultMedia.budget = ((resultMedia.budgetRatio /100) * (this.totalBudget)).toFixed(2);
        resultMedia.af = (resultMedia.grps / resultMedia.reach1).toFixed(2);
        resultMedia.grps = resultMedia.grps.toFixed(2);
        resultMedia.reach1 = resultMedia.reach1.toFixed(2);

        this.displayMediaList.push(resultMedia);
        allocationMedia.media1 = 'TV';
        allocationMedia.media1Reach1 = resultMedia.reach1;

      }
      if(this.finalMediaResult.pcMedia.resultMedia != null){
        var resultMedia = this.$_.clone(this.finalMediaResult.pcMedia.resultMedia);
        resultMedia.budgetRatio = 0;
        for(var i=0; i<this.formData.mediaListResult.length; i++){
          if(this.formData.mediaListResult[i].media == 'PC'){
            resultMedia.budgetRatio += this.formData.mediaListResult[i].budgetRatio;

            var channel = this.formData.mediaListResult[i].channel;
            this.finalMediaResult.pcMedia.mediaList[channel].budgetRatio = this.formData.mediaListResult[i].budgetRatio;
            this.formData.mediaListResult[i].grps = this.formData.mediaListResult[i].grps.toFixed(2);
            this.formData.mediaListResult[i].reach1 = this.formData.mediaListResult[i].reach1.toFixed(2);
            this.formData.mediaListResult[i].af = (this.formData.mediaListResult[i].grps/this.formData.mediaListResult[i].reach1).toFixed(2);
            this.formData.mediaListResult[i].budget = ((this.formData.mediaListResult[i].budgetRatio /100) * (this.totalBudget)).toFixed(2);

            this.formData.mediaListResult[i].name = this.formData.mediaListResult[i].channel;
            this.formData.mediaListResult[i].size = this.formData.mediaListResult[i].budgetRatio;
            this.finalMediaResult.pcMedia.mediaListArr.push(this.$_.clone(this.formData.mediaListResult[i]));
          }
        }
        resultMedia.budget = ((resultMedia.budgetRatio /100) * (this.totalBudget)).toFixed(2);
        resultMedia.af = (resultMedia.grps / resultMedia.reach1).toFixed(2);
        resultMedia.grps = resultMedia.grps.toFixed(2);
        resultMedia.reach1 = resultMedia.reach1.toFixed(2);

        this.displayMediaList.push(resultMedia);
        allocationMedia.media2 = 'PC';
        allocationMedia.media2Reach1 = resultMedia.reach1;
      }
      if(this.finalMediaResult.mobileMedia.resultMedia != null){
        var resultMedia = this.$_.clone(this.finalMediaResult.mobileMedia.resultMedia);
        resultMedia.budgetRatio = 0;
        for(var i=0; i<this.formData.mediaListResult.length; i++){
          if(this.formData.mediaListResult[i].media == 'Mobile'){
            resultMedia.budgetRatio += this.formData.mediaListResult[i].budgetRatio;

            var channel = this.formData.mediaListResult[i].channel;
            this.finalMediaResult.mobileMedia.mediaList[channel].budgetRatio = this.formData.mediaListResult[i].budgetRatio;
            this.formData.mediaListResult[i].grps = this.formData.mediaListResult[i].grps.toFixed(2);
            this.formData.mediaListResult[i].reach1 = this.formData.mediaListResult[i].reach1.toFixed(2);
            this.formData.mediaListResult[i].af = (this.formData.mediaListResult[i].grps/this.formData.mediaListResult[i].reach1).toFixed(2);
            this.formData.mediaListResult[i].budget = ((this.formData.mediaListResult[i].budgetRatio /100) * (this.totalBudget)).toFixed(2);

            this.formData.mediaListResult[i].name = this.formData.mediaListResult[i].channel;
            this.formData.mediaListResult[i].size = this.formData.mediaListResult[i].budgetRatio;
            this.finalMediaResult.mobileMedia.mediaListArr.push(this.$_.clone(this.formData.mediaListResult[i]));
          }
        }
        resultMedia.budget = ((resultMedia.budgetRatio /100) * (this.totalBudget)).toFixed(2);
        resultMedia.af = (resultMedia.grps / resultMedia.reach1).toFixed(2);
        resultMedia.grps = resultMedia.grps.toFixed(2);
        resultMedia.reach1 = resultMedia.reach1.toFixed(2);

        this.displayMediaList.push(resultMedia);
        allocationMedia.media3 = 'Mobile';
        allocationMedia.media3Reach1 = resultMedia.reach1;
      }
      if(this.finalMediaResult.digitalMedia.resultMedia != null){
        var resultMedia = this.$_.clone(this.finalMediaResult.digitalMedia.resultMedia);
        resultMedia.budgetRatio = 0;
        for(var i=0; i<this.formData.mediaListResult.length; i++){
          if(this.formData.mediaListResult[i].media == 'Digital'){
            resultMedia.budgetRatio += this.formData.mediaListResult[i].budgetRatio;

            var channel = this.formData.mediaListResult[i].channel;
            this.finalMediaResult.digitalMedia.mediaList[channel].budgetRatio = this.formData.mediaListResult[i].budgetRatio;
            this.formData.mediaListResult[i].grps = this.formData.mediaListResult[i].grps.toFixed(2);
            this.formData.mediaListResult[i].reach1 = this.formData.mediaListResult[i].reach1.toFixed(2);
            this.formData.mediaListResult[i].af = (this.formData.mediaListResult[i].grps/this.formData.mediaListResult[i].reach1).toFixed(2);
            this.formData.mediaListResult[i].budget = ((this.formData.mediaListResult[i].budgetRatio /100) * (this.totalBudget)).toFixed(2);

            this.formData.mediaListResult[i].name = this.formData.mediaListResult[i].channel;
            this.formData.mediaListResult[i].size = this.formData.mediaListResult[i].budgetRatio;
            this.finalMediaResult.digitalMedia.mediaListArr.push(this.$_.clone(this.formData.mediaListResult[i]));
          }
        }
        resultMedia.budget = ((resultMedia.budgetRatio /100) * (this.totalBudget)).toFixed(2);
        resultMedia.af = (resultMedia.grps / resultMedia.reach1).toFixed(2);
        resultMedia.grps = resultMedia.grps.toFixed(2);
        resultMedia.reach1 = resultMedia.reach1.toFixed(2);

        this.displayMediaList.push(resultMedia);
        allocationMedia.media4 = 'Digital';
        allocationMedia.media4Reach1 = resultMedia.reach1;
      }

      this.allocationMediaList.push(allocationMedia);
      mediaReachResultBarChart.drawChart(this.allocationMediaList);
      this.$log.debug('makeDisplayData 종료 , 화면에 보여줄 결과 데이터 만들기');
    },
    makeSunburstData(){
      this.$log.debug('makeSunburstData 시작 , 선버스트 차트 데이터 만들기');
      if(this.finalMediaResult.tvMedia.resultMedia != null){
        var node={};
        this.makeParentSize(this.finalMediaResult.tvMedia.resultMedia, this.finalMediaResult.tvMedia.mediaListArr);
        node.name = "TV " + this.finalMediaResult.tvMedia.resultMedia.size + '%';

        node.children = this.finalMediaResult.tvMedia.mediaListArr
        this.makeNodeName(node.children);

        this.mediaSunburstData.children.push(node);
      }
      if(this.finalMediaResult.pcMedia.resultMedia != null){
        var node={};
        this.makeParentSize(this.finalMediaResult.pcMedia.resultMedia, this.finalMediaResult.pcMedia.mediaListArr);
        node.name = "PC " + this.finalMediaResult.pcMedia.resultMedia.size + '%';

        node.children = this.finalMediaResult.pcMedia.mediaListArr
        this.makeNodeName(node.children);

        this.mediaSunburstData.children.push(node);
      }
      if(this.finalMediaResult.mobileMedia.resultMedia != null){
        var node={};
        this.makeParentSize(this.finalMediaResult.mobileMedia.resultMedia, this.finalMediaResult.mobileMedia.mediaListArr);
        node.name = "Mobile \n" + this.finalMediaResult.mobileMedia.resultMedia.size + '%';

        node.children = this.finalMediaResult.mobileMedia.mediaListArr
        this.makeNodeName(node.children);

        this.mediaSunburstData.children.push(node);
      }
      if(this.finalMediaResult.digitalMedia.resultMedia != null){
        var node={};
        this.makeParentSize(this.finalMediaResult.digitalMedia.resultMedia, this.finalMediaResult.digitalMedia.mediaListArr);
        node.name = "Digital \n" + this.finalMediaResult.digitalMedia.resultMedia.size + '%';

        node.children = this.finalMediaResult.digitalMedia.mediaListArr
        this.makeNodeName(node.children);

        this.mediaSunburstData.children.push(node);
      }
      this.showResult = true;
      this.$log.debug('makeSunburstData 종료 , 선버스트 차트 데이터 만들기');
    },
    makeNodeName(children){
      for(var i=0; i<children.length; i++){
        children[i].name = children[i].name +" "+children[i].size + '%';
      }
    },
    makeParentSize(parent, children){
      parent.size = 0;
      for(var i=0; i<children.length; i++){
        parent.size += children[i].size;
      }
    },
    changeDisplayChannelList(media){
      //displayChannelList
      switch (media) {
        case "TV":
          this.displayChannelList = this.finalMediaResult.tvMedia.mediaListArr;
          break;
        case "PC":
          this.displayChannelList = this.finalMediaResult.pcMedia.mediaListArr;
          break;
        case "Mobile":
          this.displayChannelList = this.finalMediaResult.mobileMedia.mediaListArr;
          break;
        case "Digital":
          this.displayChannelList = this.finalMediaResult.digitalMedia.mediaListArr;
          break;
        default:
      }
      for(var i=0; i< this.displayMediaList.length; i++){
        if(media === this.displayMediaList[i].media){
          this.mediaInfoForChannel = this.displayMediaList[i];
        }
      }
      channelReachResultChart.drawChart(this.displayChannelList);
    },
    selectFirstRow(){
      var first = $("#mediaResultTable>tbody>tr:first").trigger('click');
      this.mediaInfoForChannel = this.displayMediaList[0];
      this.changeDisplayChannelList(this.displayMediaList[0].media);
    },
    myRowClickHandler(record, index, event) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      if(event.isTrusted){
        $(event.path[1]).addClass('selectedActiveGrey').siblings().removeClass('selectedActiveGrey');
      }else{
        $(event.path[0]).addClass('selectedActiveGrey').siblings().removeClass('selectedActiveGrey');
      }
      // console.log(record); // This will be the item data for the row
      this.changeDisplayChannelList(record.media);
    },
    budgetChange(){
      this.$log.debug('budgetChange 시작 : 각종 변수 초기화');
      this.displayMediaList=[],
      this.displayChannelList=[],
      this.mediaInfoForChannel={},
      this.mediaIndexA=[1, 1, 1, 1, 1, 1, 1, 1, 1],
      this.mediaIndexB=[1, 1, 1, 1, 1, 1, 1, 1, 1],
      this.mediaSunburstData={
        "name": "flare",
        "children": []
      };
      this.$root.$emit('bv::refresh::table', 'mediaResultTable');
      this.$log.debug('budgetChange 종료');
    },
    createSunburst(){
      let width = 430,
          height = 400,
          radius = (Math.min(width, height) / 2) - 10,
          node
      d3.select('#sunburstChart').selectAll('svg').remove();
      const svg = d3.select('#sunburstChart') // #sunburstChart
                    .append('svg')
                    .attr('width', width)
                    .attr('height', height)
                    .append('g')
                    .attr('transform', 'translate(' + width / 2 + ',' + (height / 2) + ')')

      const x = d3.scaleLinear().range([0, 2 * Math.PI])
      const y = d3.scaleLinear().range([0, radius])

      const colors = d3.scaleOrdinal(d3.schemeCategory20)
      const partition = d3.partition()

      const arc = d3.arc()
        .startAngle(d => Math.max(0, Math.min(2 * Math.PI, x(d.x0))))
        .endAngle(d => Math.max(0, Math.min(2 * Math.PI, x(d.x1))))
        .innerRadius(d => Math.max(0, y(d.y0)))
        .outerRadius(d => Math.max(0, y(d.y1)))


      // 데이터 읽어와서 화면 그리기
      const gSlices = svg.selectAll('g').data(partition(d3.hierarchy(this.mediaSunburstData).sum(d => d.size)).descendants(), function (d) { return d.data.id }).enter().append('g')

      gSlices.exit().remove()

      gSlices.append('path')
             .style('fill', function (d) {
               if (d.depth === 0) return 'white'
               return colors(d.x0)
             })
             .on('click', click)

      gSlices.append('text')
             .attr('dy', '.35em')
             // .text(function (d) { return d.parent ? d.data.name +'('+d.data.size+')' : '' })
             .text(function (d) { return d.parent ? d.data.name : '' })
             .attr('id', function (d) { return 'w' + d.data.name })
             .call(wrap, 40) // 19.09.27 추가 https://code.i-harness.com/ko-kr/q/ca0c83
             .attr('fill', '#000')

      svg.selectAll('path')
         .transition('update')
         .duration(0).attrTween('d', function (d, i) {
           return arcTweenPath(d, i)
         })

      svg.selectAll('text')
         .transition('update')
         .duration(0)
         .attrTween('transform', function (d, i) { return arcTweenText(d, i)})
         .attr('text-anchor', function (d) {
           return d.textAngle > 180 ? 'start' : 'end'
         })
         .attr('dx', function (d) {
           return d.textAngle > 180 ? 27: 27
         })
         .attr('opacity', function (e) {
          return e.x1 - e.x0 > 0.01 ? 1 : 0
         })

         function wrap(text, width) {
             text.each(function() {
                 var text = d3.select(this),
                 words = text.text().split(/\n+/).reverse(),
                 word,
                 line = [],
                 lineNumber = 0,
                 y = text.attr("y"),
                 dy = parseFloat(text.attr("dy")),
                 lineHeight = 1.1; // ems

                 var tspan = text.text(null).append("tspan").attr("x", function(d) { return d.children || d._children ? -10 : 10; }).attr("y", y).attr("dy", dy + "em");
                 var index = 0;
                 while (word = words.pop()) {
                     line.push(word);
                     tspan.text(line.join(" "));
                     var textWidth = tspan.node().getComputedTextLength();
                     if(index >= 1){
                           line.pop();
                           tspan.text(line.join(" "));
                           line = [word];
                           ++lineNumber;
                       tspan = text.append("tspan").attr("x", function(d) { return d.children || d._children ? 0 : -10; }).attr("y", 0).attr("dy", lineNumber * lineHeight + dy + "em").text(word);
                     }
                     index++;
                 }
             });
         }


      function arcTweenText(a, i) {
        var oi = d3.interpolate({ x0: (a.x0s ? a.x0s : 0), x1: (a.x1s ? a.x1s : 0), y0: (a.y0s ? a.y0s : 0), y1: (a.y1s ? a.y1s : 0) }, a)

        function tween(t) {
          var b = oi(t)
          var ang = ((x((b.x0 + b.x1) / 2) - Math.PI / 2) / Math.PI * 180)

          b.textAngle = (ang > 90) ? 180 + ang : ang
          a.centroid = arc.centroid(b)

          return 'translate(' + arc.centroid(b) + ')rotate(' + b.textAngle + ')'
        }
        return tween
      }

      function arcTweenPath(a, i) {
        var oi = d3.interpolate({ x0: (a.x0s ? a.x0s : 0), x1: (a.x1s ? a.x1s : 0), y0: (a.y0s ? a.y0s : 0), y1: (a.y1s ? a.y1s : 0) }, a)

        function tween(t) {
          var b = oi(t)

          a.x0s = b.x0
          a.x1s = b.x1
          a.y0s = b.y0
          a.y1s = b.y1

          return arc(b)
        }
        if (i == 0 && node) {

          var xd = d3.interpolate(x.domain(), [node.x0, node.x1])
          var yd = d3.interpolate(y.domain(), [node.y0, 1])
          var yr = d3.interpolate(y.range(), [node.y0 ? 40 : 0, radius])

          return function (t) {
            x.domain(xd(t))
            y.domain(yd(t)).range(yr(t))

            return tween(t)
          }
        } else {
          // first build
          return tween
        }
      }

      function click(d) {
        node = d
        const total = d.x1 - d.x0

        svg.selectAll('path')
           .transition('click')
           .duration(750)
           .attrTween('d', function (d, i) { return arcTweenPath(d, i)})

        svg.selectAll('text')
           .transition('click')
           .attr('opacity', 1)
           .duration(750)
           .attrTween('transform', function (d, i) {
             return arcTweenText(d)
            })
           .attr('text-anchor', function (d) {
             return d.textAngle > 180 ? 'start' : 'end'
           })
           .attr('dx', function (d) {
             if(d.data.name.length > 3) {
               return d.textAngle > 180 ? -23 : 23
             }
             return d.textAngle > 180 ? -13 : 13
           })
           .attr('opacity', function (e) {
             // hide & show text
             if (e.x0 >= d.x0 && e.x1 <= (d.x1 + 0.0000000000000001)) {
               const arcText = d3.select(this.parentNode).select('text')
               arcText.attr('visibility', function(d) {
                 return (d.x1 - d.x0) / total < 0.01 ? 'hidden' : 'visible'
               })
             } else {
               return 0
             }
           })
       }
    },
    excelDown(){
      this.constFormData.totalBudget = this.totalBudget;
      var token = sessionStorage.getItem("myToken");
      var formdata = JSON.stringify(this.constFormData);
      var result = JSON.stringify(this.finalMediaResult);
      var resultchannel = JSON.stringify(this.displayMediaList);
      var data = new FormData();

      data.append('formdata', formdata);
      data.append('result', result);
      data.append('resultchannel', resultchannel);

      var config = {
        responseType: 'blob'
      };
      this.$http.post('/excel/mediaReachResultDown',data,config)
        .then((result) => {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = url;
          var fileName = this.constFormData.campaignTitle.replace(/ /gi, '');
          fileName = fileName + "_미디어목표도달율_" + moment().format('YYYYMMDD') ;
          link.setAttribute('download', fileName + '.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
  }
}
</script>

<style scoped>
.CSSAnimationChart,
.mapChart {
    width: 100%;
    height: 380px
}
</style>



// WEBPACK FOOTER //
// src/views/budget/MediaReachResult.vue